import { Group, InputText, Item, SearchForm } from 'mailup-web-components'
import { useIntl } from 'react-intl'
import { useRecoilCallback, useRecoilValue, useSetRecoilState } from 'recoil'
import { getCampaignListCallback } from '../recoil/callbacks/callbacks'
import { searchState } from '../recoil/state/page'

const Search = () => {
  const intl = useIntl()

  const { campaignName } = useRecoilValue(searchState)
  const setSearchState = useSetRecoilState(searchState)
  const getCampaignList = useRecoilCallback(getCampaignListCallback, [])

  const handleKeyPress = (e) => {
    if (e.key === 'Enter') {
      getCampaignList({})
    }
  }

  const handleSubmit = (e) => {
    getCampaignList({})
  }

  const handleReset = (e) => {
    getCampaignList({ isReset: true })
  }

  const handleInputChange = (e) => {
    setSearchState((prev) => ({
      ...prev,
      campaignName: e.target.value
    }))
  }

  return (
    <>
      <SearchForm
        labelBtnReset={intl.formatMessage({ id: 'Load.MailupCommon.Reset' })}
        labelBtnSearch={intl.formatMessage({ id: 'Load.MailupCommon.Search' })}
        onClickToggle={() => {}}
        onClickReset={handleReset}
        onSubmit={handleSubmit}
        advanced={false}
      >
        <Group>
          <Item>
            <InputText
              placeholder={intl.formatMessage({
                id: 'Load.ContentsCampaignList.SearchTextPlaceholder'
              })}
              value={campaignName}
              onChange={handleInputChange}
              onKeyPress={handleKeyPress}
            />
          </Item>
        </Group>
      </SearchForm>
    </>
  )
}

export default Search
